






import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Agreement extends Vue {
  private loaded: boolean = false;
  private result: any = "";
  private msOfficeUrl: any =
    "https://view.officeapps.live.com/op/view.aspx?src=";
  private uri: any = "";
  private beforeMount() {
    this.uri = localStorage.getItem("word-preview");
  }
  private mounted() {
    const url = encodeURI(this.uri);
    this.result = this.msOfficeUrl + url;
    this.loaded = true;
  }
}
